<template>
  <div
    id="accept-sam-application"
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <form
                v-if="samApplication"
                class="p-8 login-tabs-container"
                @submit.prevent="requestReset"
              >
                <div class="vx-card__title">
                  <h4 class="pb-4">Bewerbung Ihres Kindes</h4>
                  <p>
                    Ihr Kind, {{ samApplication.firstName }}
                    {{ samApplication.lastName }}, hat sich bei Select aufe eine
                    Ausbildung beworben. Da es unter 16 Jahre alt ist müssen Sie
                    diese Bewerbung bestätigen, bevor wir sie verarbeiten
                    können. Wenn Sie die Dewerbung nicht bestätigen erlischt sie
                    innerhalb von zwei Wochen automatisch.
                  </p>
                </div>

                <div>
                  <DataInput
                    v-model="applicationConfirmed"
                    required
                    type="bool"
                    class="w-full mt-4"
                    label="Bewerbung bestätigen"
                    name="applicationConfirmed"
                  />

                  <label class="mt-4 block">
                    <input
                      v-model="dataPolicy"
                      type="checkbox"
                      required
                      name="data-policy"
                    />
                    Ich habe die
                    <a href=" https://www.sam4future.de/datenschutz"
                      >Datenschutzerklärung</a
                    >
                    und die darin enthaltenen Informationen zur Kenntnis
                    genommen. Hiermit erteile ich meine Einwilligung für die
                    Verarbeitung meiner personenbezogenen Daten (weitere
                    Informationen zur Einwilligung finden Sie
                    <a
                      href=" https://sam4future.de/verarbeitung-personenbezogener-daten/"
                      >hier</a
                    >).
                  </label>

                  <vs-button
                    :disabled="!(applicationConfirmed && dataPolicy)"
                    class="mt-4"
                    @click="confirmApplicant"
                    >Absenden zum Bestätigen</vs-button
                  >
                </div>
              </form>
              <div v-else class="p-8 login-tabs-container">
                <div class="vx-card__title">
                  <h4 class="pb-4">Link Abgelaufen</h4>
                  <p>
                    Wir konnten keine bewerbung zu diesem link finden. Die
                    angegeben URL ist abgelaufen oder falsch
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  data: () => ({
    applicationConfirmed: null,
    dataPolicy: null
  }),
  apollo: {
    samApplication: {
      query: gql`
        query($secret: String!) {
          samApplicantInfoByLinkSecret(secret: $secret) {
            firstName
            lastName
          }
        }
      `,
      variables() {
        return { secret: this.$route.params.code };
      },
      update(data) {
        console.log(data);
        return data.samApplicantInfoByLinkSecret;
      }
    }
  },
  methods: {
    confirmApplicant() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($secret: String!) {
              verifiySamApplication(secret: $secret)
            }
          `,
          variables: {
            secret: this.$route.params.code
          }
        })
        .then(() => {
          this.$vs.notify({
            title: "Bewerbung",
            text:
              "Bewerbung erfolgreich bestätigt. Sie werden gleich weitergeleitet.",
            color: "success",
            icon: "mail_outline",
            time: 3000,
            position: "bottom-center"
          });
          setTimeout(() => {
            window.location.href = "https://www.sam4future.de";
          }, 3100);
          this.applicationConfirmed = false;
        });
    }
  }
};
</script>
<style lang="scss">
@import "src/assets/scss/views/sam-application.scss";
</style>
